// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPackageGetOrderResponse

import { CustomerPackageOrderStatus } from './enums.gen';

export type WidgetPackageGetOrderApiResponse = {
	id: string;
	amount: number;
	package_id: string | null;
	customer_package_id: string | null;
	status: CustomerPackageOrderStatus | null;
	discountAmount: number | null;
	discountCode: string | null;
};

export type WidgetPackageGetOrder = {
	id: string;
	amount: number;
	package_id: string | null;
	customer_package_id: string | null;
	status: CustomerPackageOrderStatus | null;
	discountAmount: number | null;
	discountCode: string | null;
};

export function hydrateWidgetPackageGetOrder(data: WidgetPackageGetOrderApiResponse): WidgetPackageGetOrder {
	return { ...data };
}